module.exports = __webpack_public_path__ + "img/chevron_right.6a6d7033.svg";